import {
  lesson12Assignment,
} from './assignments'
import { createChessboard } from '../../utils';
import { WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE, BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE } from '../../utils/constants';

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 18,
    video: {
      src: 'img/videos/lesson_12/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 18,
    audio: { src: 'img/audio/lesson_12/1.mp3', start: true, controls: false },
    directions: {
      timeout: 8000,
      data: '<b>DIRECTIONS:</b> </br>Move the Black Rook so that he is checking the White King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/5k1r/6r1/2K5/8/8/8/8',
        final: '8/5k2/6r1/2K4r/8/8/8/8',
        next: 2,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
        initialMove: BLACK_INITIAL_MOVE,
        wrongMessage: 'Oops! <br/> That Rook was building a wall.'
      }),
      positionFen: '8/5k1r/6r1/2K5/8/8/8/8 b - - 0 1',
    }
  },
  {
    id: 2,
    previous: 0,
    next: 18,
    video: {
      src: 'img/videos/lesson_12/activty1_1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3
    }
  },
  {
    id: 3,
    previous: 0,
    next: 18,
    audio: { src: 'img/audio/lesson_12/Activty1_1.mp3', start: true, controls: false },
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/6r1/2K4r/8/8/8/8',
        final: '8/5k2/6r1/7r/3K4/8/8/8',
        assignmentClass: 'custom-sparepiece',
        from: 'c5',
        to: 'd4',
        next: 4,
        computerMoveIn: 16000
      }),
    }
  },
  {
    id: 4,
    previous: 0,
    next: 18,
    directions: {
      data: `<b>DIRECTIONS:</b> </br>Click on the Rook who isn't doing <br/> anything and move him to check the King`,
      position: 'left',
      styleClass: 'xxl',
      timeout: 1000
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/5k2/6r1/7r/3K4/8/8/8',
        final: '8/5k2/8/7r/3K2r1/8/8/8',
        next: 5,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
        initialMove: BLACK_INITIAL_MOVE,
        wrongMessage: 'oops, <br/> that won’t check the King',
        otherRookMovementMessage: 'That Rook was busy building a wall.<br/> Move the other Rook'
      }),
      positionFen: '8/5k2/6r1/7r/3K4/8/8/8 b - - 0 1',
    }
  },
  {
    id: 5,
    previous: 0,
    next: 18,
    audio: { src: 'img/audio/lesson_12/7.mp3', start: true, controls: false },
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/7r/3K2r1/8/8/8',
        final: '8/5k2/8/7r/6r1/4K3/8/8',
        assignmentClass: 'custom-sparepiece',
        from: 'd4',
        to: 'e3',
        next: 6,
        computerMoveIn: 5000
      }),
    }
  },
  {
    id: 6,
    previous: 0,
    next: 18,
    video: {
      src: 'img/videos/lesson_12/activity1_2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 7
    }
  },
  {
    id: 7,
    previous: 0,
    next: 18,
    directions: {
      data: '<b>DIRECTIONS:</b> </br>Click on the Rook who isn’t doing <br/> anything and move him to check the King.',
      styleClass: 'md'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/5k2/8/7r/6r1/4K3/8/8',
        final: '8/5k2/8/8/6r1/4K2r/8/8',
        next: 8,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
        initialMove: BLACK_INITIAL_MOVE,
        wrongMessage: 'oops, <br/> that won’t check the King',
        otherRookMovementMessage: 'oops <br/> That wont check the king'
      }),
      positionFen: '8/5k2/8/7r/6r1/4K3/8/8 b - - 0 1',
    }
  },
  {
    id: 8,
    previous: 0,
    next: 18,
    audio: { src: 'img/audio/lesson_12/7.mp3', start: true, controls: false },
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/8/6r1/4K2r/8/8',
        final: '8/5k2/8/8/6r1/7r/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'e3',
        to: 'f2',
        next: 9,
        computerMoveIn: 5000
      }),
    }
  },
  {
    id: 9,
    previous: 0,
    next: 18,
    audio: { src: 'img/audio/lesson_12/activity1_5.mp3', start: true, controls: false },
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/8/6r1/7r/5K2/8',
        final: '8/5k2/8/8/r7/7r/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'g4',
        to: 'a4',
        next: 10,
        prefilledCoordinates: ['.square-g2'],
        filledSquareTimeOut: 1000,
        computerMoveIn: 12000
      }),
    }
  },
  {
    id: 10,
    previous: 0,
    next: 18,
    audio: { src: 'img/audio/lesson_12/activity1_3.mp3', start: true, controls: false },
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/8/r7/7r/5K2/8',
        final: '8/5k2/8/8/r7/7r/6K1/8',
        assignmentClass: 'custom-sparepiece',
        from: 'f2',
        to: 'g2',
        next: 11,
        computerMoveIn: 5000
      }),
    }
  },
  {
    id: 11,
    previous: 0,
    next: 18,
    video: {
      src: 'img/videos/lesson_12/activity1_3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 12
    }
  },
  {
    id: 12,
    previous: 0,
    next: 18,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/8/r7/7r/6K1/8',
        final: '8/5k2/8/8/r7/1r6/6K1/8',
        assignmentClass: 'custom-sparepiece',
        from: 'h3',
        to: 'b3',
        next: 13,
        computerMoveIn: 2000
      }),
    }
  },
  {
    id: 13,
    previous: 0,
    next: 18,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/8/r7/1r6/6K1/8',
        final: '8/5k2/8/8/r7/1r6/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'g2',
        to: 'f2',
        next: 14,
        computerMoveIn: 3000
      }),
    }
  },
  {
    id: 14,
    previous: 0,
    next: 18,
    audio: { src: 'img/audio/lesson_12/activity1_4.mp3', start: true, controls: false },
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/8/r7/1r6/5K2/8',
        final: '8/5k2/8/8/8/1r6/r4K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'a4',
        to: 'a2',
        next: 15,
        prefilledCoordinates: ['.square-a4', '.square-b3'],
        filledSquareTimeOut: 200,
        newFilledSquares: true,
        fromCanvas: 'square-a2',
        toCanvas: 'square-b3',
        offset: [5, 5, 5, 2],
        computerMoveIn: 8000
      }),
      canvas: true
    }
  },
  {
    id: 15,
    previous: 0,
    next: 18,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/5k2/8/8/8/1r6/r4K2/8',
        final: '8/5k2/8/8/8/1r6/r7/4K3',
        assignmentClass: 'custom-sparepiece',
        from: 'f2',
        to: 'e1',
        next: 16,
        computerMoveIn: 5000
      }),
    }
  },
  {
    id: 16,
    previous: 0,
    next: 18,
    video: {
      src: 'img/videos/lesson_12/activity1_4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 17
    }
  },
  {
    id: 17,
    previous: 0,
    next: 18,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Now choose the Rook that is not building the  wall, and finally checkmate the  King!',
      styleClass: 'xl'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/5k2/8/8/8/1r6/r7/4K3',
        final: '8/5k2/8/8/8/8/r7/1r2K3',
        next: 18,
        showIndicators: { allSides: true },
        MagnusText: 'LadderMate',
        restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
        initialMove: BLACK_INITIAL_MOVE,
        filledSquareTimeOut: 1000,
        wrongMessage: 'Oops! That’s the wrong Rook for checkmate.',
        magnusPopUp: true
      }),
      positionFen: '8/5k2/8/8/8/1r6/r7/4K3 b - - 0 1',
    }
  },
  {
    id: 18,
    previous: 0,
    next: 32,
    video: {
      src: 'img/videos/lesson_12/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 19
    }
  },
  {
    id: 19,
    previous: 18,
    next: 32,
    audio: { src: 'img/audio/lesson_12/10.mp3', start: true, controls: false },
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Alternate the Rooks so they are both busy building walls, and one checks the King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/8/8/8/1k6/6R1/5K1R/8',
        final: '8/8/8/8/1k5R/6R1/5K2/8',
        next: 20,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        wrongMessage: `oops!That's not the correct move.`
      }),
      positionFen: '8/8/8/8/1k6/6R1/5K1R/8 w - - 0 1',
    }
  },
  {
    id: 20,
    previous: 18,
    next: 32,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/8/8/8/1k5R/6R1/5K2/8',
        final: '8/8/8/2k5/7R/6R1/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'b4',
        to: 'c5',
        next: 21
      }),
    }
  },
  {
    id: 21,
    previous: 18,
    next: 32,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/8/8/2k5/7R/6R1/5K2/8',
        final: '8/8/8/2k3R1/7R/8/5K2/8',
        next: 22,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        wrongMessage: `oops!That's not the correct move.`
      }),
      positionFen: '8/8/8/2k5/7R/6R1/5K2/8 w - - 0 1',
    }
  },
  {
    id: 22,
    previous: 18,
    next: 32,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/8/8/2k3R1/7R/8/5K2/8',
        final: '8/8/3k4/6R1/7R/8/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'c5',
        to: 'd6',
        next: 23
      }),
    }
  },
  {
    id: 23,
    previous: 18,
    next: 32,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/8/3k4/6R1/7R/8/5K2/8',
        final: '8/8/3k3R/6R1/8/8/5K2/8',
        next: 24,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        wrongMessage: `oops!That's not the correct move.`
      }),
      positionFen: '8/8/3k4/6R1/7R/8/5K2/8 w - - 0 1',
    }
  },
  {
    id: 24,
    previous: 18,
    next: 32,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/8/3k3R/6R1/8/8/5K2/8',
        final: '8/4k3/7R/6R1/8/8/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'd6',
        to: 'e7',
        next: 25,
      }),
    }
  },
  {
    id: 25,
    previous: 18,
    next: 32,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '8/4k3/7R/6R1/8/8/5K2/8',
        final: '8/4k1R1/7R/8/8/8/5K2/8',
        next: 26,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        wrongMessage: `oops!That's not the correct move.`
      }),
      positionFen: '8/4k3/7R/6R1/8/8/5K2/8 w - - 0 1',
    }
  },
  {
    id: 26,
    previous: 18,
    next: 32,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '8/4k1R1/7R/8/8/8/5K2/8',
        final: '5k2/6R1/7R/8/8/8/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'e7',
        to: 'f8',
        next: 27,
      }),
    }
  },
  {
    id: 27,
    previous: 18,
    next: 32,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '5k2/6R1/7R/8/8/8/5K2/8',
        final: '5k2/R7/7R/8/8/8/5K2/8',
        next: 28,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        wrongMessage: `oops!That's not the correct move.`
      }),
      positionFen: '5k2/6R1/7R/8/8/8/5K2/8 w - - 0 1',
    }
  },
  {
    id: 28,
    previous: 18,
    next: 32,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '5k2/R7/7R/8/8/8/5K2/8',
        final: '6k1/R7/7R/8/8/8/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'f8',
        to: 'g8',
        next: 29,
      }),
    }
  },
  {
    id: 29,
    previous: 18,
    next: 32,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '6k1/R7/7R/8/8/8/5K2/8',
        final: '6k1/R7/1R6/8/8/8/5K2/8',
        next: 30,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        wrongMessage: `oops!That's not the correct move.`
      }),
      positionFen: '6k1/R7/7R/8/8/8/5K2/8 w - - 0 1',
    }
  },
  {
    id: 30,
    previous: 18,
    next: 32,
    chessboard: {
      board: lesson12Assignment({
        showIndicators: { allSides: true },
        position: '6k1/R7/1R6/8/8/8/5K2/8',
        final: '5k2/R7/1R6/8/8/8/5K2/8',
        assignmentClass: 'custom-sparepiece',
        from: 'g8',
        to: 'f8',
        next: 31,
      }),
    }
  },
  {
    id: 31,
    previous: 18,
    next: 32,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'
    },
    chessboard: {
      board: lesson12Assignment({
        position: '5k2/R7/1R6/8/8/8/5K2/8',
        final: '1R3k2/R7/8/8/8/8/5K2/8',
        next: 32,
        showIndicators: { allSides: true },
        timeout: 5000,
        MagnusText: 'Ladder Mate',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        wrongMessage: `oops!That's not the correct move.`,
        magnusPopUp: true
      }),
      positionFen: '5k2/R7/1R6/8/8/8/5K2/8 w - - 0 1',
    }
  },
  {
    id: 32,
    previous: 18,
    next: 33,
    video: {
      src: 'img/videos/lesson_12/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 33
    }
  },
  {
    id: 33,
    previous: 32,
    next: 34,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'Which are your “wall building” pieces?',
      answer: [
        'Bishops and Rooks',
        'Rooks and Queens',
        'Knights and Bishops',
        'Queens and Knights'
      ],
      rightAnswer: 'Rooks and Queens',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 34,
    previous: 32,
    next: 35,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'Where can your Queen or Rooks build a wall?',
      answer: [
        'On a file and a rank',
        'Only on a file',
        'Only on a rank',
        'Only on the diagonal'
      ],
      rightAnswer: 'On a file and a rank',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 35,
    previous: 32,
    next: 36,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'Which pieces can be used in a ladder mate?',
      answer: [
        'A Rook and a Knight',
        'A Bishop and a Knight',
        'Two Bishops',
        'Two Rooks'
      ],
      rightAnswer: 'Two Rooks',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 36,
    previous: 32,
    next: 37,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: 'When creating a ladder mate you should...',
      answer: [
        'Play as quickly as possible',
        'Only move one Rook',
        'Be patient and move slowly',
        'Move both Rooks at the same time'
      ],
      rightAnswer: 'Be patient and move slowly',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 37,
    previous: 32,
    next: 38,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'The White King just moved to f2. What should Black do next?',
      answer: [
        'Move to g2 for check',
        'Move to h2 for check',
        'Move to a4',
        'Offer a draw'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/5k2/8/8/6r1/7r/5K2/8'
        }),
        hint: true,
        canvas: {
          from: 'square-e3',
          to: 'square-f2'
        }
      },
      rightAnswer: 'Move to a4',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 38,
    previous: 32,
    next: 39,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'The White King has just moved to b1. Which move will checkmate the White King?',
      answer: [
        'Rb2#',
        'Kb2#',
        'Rg1#',
        'Rd2#'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/8/8/8/8/1k6/6r1/1K6'
        }),
        hint: true,
        canvas: {
          from: 'square-a1',
          to: 'square-b1'
        }
      },
      rightAnswer: 'Rg1#',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 39,
    previous: 32,
    next: 40,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'How many moves will it take for White to checkmate Black?',
      answer: [
        '1',
        '2',
        '3',
        '4'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/7k/1R6/R7/7K/8/8/8'
        }),
        hint: true,
      },
      rightAnswer: '2',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'sm'
    }
  },
  {
    id: 40,
    previous: 32,
    next: 41,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'When creating a Ladder Mate with two Rooks, the Rooks should…',
      answer: [
        'Stay on the same file a-h',
        'Stay on the same color',
        'Stay on the same rank 1-8',
        'Stay on opposite colors'
      ],
      rightAnswer: 'Stay on the same color',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 41,
    previous: 32,
    next: 42,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'One of the rules of ladder mate is…',
      answer: [
        'Move away if the King bothers you',
        'Keep your Queen a square away',
        'Light on the right',
        'Stay on opposite colors'
      ],
      rightAnswer: 'Move away if the King bothers you',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xxl'
    }
  },
  {
    id: 42,
    previous: 32,
    next: 43,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: ' In ladder mate, one of your Rooks builds a wall while the other Rook...',
      answer: [
        'Builds a second wall',
        'Protects your King',
        'Sneaks past the opposing King',
        'Checks the opposing King'
      ],
      rightAnswer: 'Checks the opposing King',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 43,
    previous: 32,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson 13',
      styleClass: 'xl',
      timeout: 7000
    }
  }
];

// ToDo: Add lesson 11 and lesson 13 images for preloading
let assets = [
  '/img/background_12.png'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_12/index.js